// utils/pageTracker.js
export const trackPageVisit = () => {
  const visitedPages = JSON.parse(sessionStorage.getItem("visitedPages")) || [];
  if (!visitedPages.includes(window.location.href)) {
    visitedPages.push(window.location.href);
    sessionStorage.setItem("visitedPages", JSON.stringify(visitedPages));
  }
};